const caseInsensitiveSort = (a, b) => {
    return a.localeCompare(b, undefined, {sensitivity: 'base'});
};

export default caseInsensitiveSort;